<template>
  <div>
    <el-tabs class="top-tab" v-model="activeStatus" type="card">
      <el-tab-pane label="Sandbox" name="Sandbox"></el-tab-pane>
      <el-tab-pane label="Sandbox模板" name="Sandbox模板"></el-tab-pane>
      <el-tab-pane label="刷新任务 " name="RefreshList"></el-tab-pane>
    </el-tabs>
    <br />
    <Sandbox v-if="activeStatus === 'Sandbox'" />
    <SandboxTemplate v-if="activeStatus === 'Sandbox模板'" />
    <RefreshList v-if="activeStatus === 'RefreshList'" />
  </div>
</template>

<script>
import Sandbox from './components/Sandbox.vue';
import SandboxTemplate from './components/SandboxTemplate.vue';
import RefreshList from './components/RefreshList.vue';
export default {
  components: {
    Sandbox,
    SandboxTemplate,
    RefreshList,
  },
  data() {
    return {
      // tab状态
      activeStatus: 'Sandbox',
    };
  },
};
</script>

<style lang="scss" scoped>
.top-tab {
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 16px;
  padding-right: 16px;
}

.el-tabs {
  ::v-deep.el-tabs__item {
    font-weight: 400;
  }
}
.el-tabs:not(.el-tabs--card) {
  height: 50px;
  margin-bottom: 16px;
  background: #fff;
  ::v-deep.el-tabs__item {
    height: 50px;
    font-size: 16px;
    width: 100px;
    text-align: center;
    padding: 0;

    &.is-active {
      color: #0069fa;
    }
  }
  ::v-deep.el-tabs__active-bar {
    height: 4px;
  }
}
.el-tabs--card {
  background: #fff;
  ::v-deep .el-tabs__header {
    border: none !important;
    margin-bottom: 0px !important;
  }
  ::v-deep .el-tabs__nav {
    border: none !important;
  }
  ::v-deep.el-tabs__item {
    border: none !important;
    height: 100%;
    &.is-active {
      border-top: 3px solid #0069fa !important;
      color: #0069fa;
      background: #f2f3f8;
    }
  }
}
</style>
